  <app-cc-table
    body #ccTable [transPartKey]="'clearing.pl-residual'"
    [tableConfig]="tableConfig" [headerButtonConfig]="headerButtonConfig"
    [contextMenuConfig]="contextMenuConfig" [(selectedRecord)]="formRecord"
    [records]="records" [totalRecords]="totalRecords" [loading]="tableLoading" [currentRequest]="tableCurrentRequest"
    (onRowDblClick)="onRowDblClick($event)" (loadRecordsEvent)="needLoadRecords($event)"
    [disableContextMenu]="true" [disableSelection]="true"
    >
  </app-cc-table>

  <div class="ml-5 font-small font-weight-500">Global P&L Residual:
    <span [textContent]="globalResidual| number : '1.0'"
          [style.color]="globalResidual >= 0 ? 'var(--yellowgreen)' : 'var(--tomato)'"></span> USD </div>
  <app-cc-detail-dialog [formConfig]="formConfig" [transPartKey]="'page_title.pl-residual' | translate"
                        [formRecord]="selectedProfile" [(dialogFormVisible)]="detailDialogVisible">
  </app-cc-detail-dialog>

